import { Waves, Wind, Bike, Map, Zap, Leaf, Compass, Mountain } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ICON_MAP = { Waves, Wind, Bike, Map, Zap, Leaf, Compass, Mountain };

function getImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `${BACKEND_URL}${url}`;
}

function ActivityCard({ activity, index }) {
  const Icon = ICON_MAP[activity.icono] || Zap;
  const delay = `animate-fade-up-delay-${Math.min(index + 1, 6)}`;

  return (
    <div
      className={`activity-card rounded-3xl overflow-hidden bg-white border border-[#E2E8F0] hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-default ${delay}`}
      data-testid={`activity-card-${activity.id}`}
    >
      {/* Image */}
      <div className="relative overflow-hidden rounded-2xl m-2">
        <div className="aspect-video">
          {activity.imagen ? (
            <img
              src={getImageUrl(activity.imagen)}
              alt={activity.nombre}
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center" style={{ background: `${activity.color}18` }}>
              <Icon size={64} color={activity.color} />
            </div>
          )}
        </div>
        <div
          className="absolute inset-0 rounded-2xl"
          style={{ background: `linear-gradient(to top, ${activity.color}cc 0%, transparent 55%)` }}
        />
        <div
          className="absolute top-3 right-3 w-10 h-10 rounded-full flex items-center justify-center shadow-lg"
          style={{ background: activity.color }}
        >
          <Icon size={20} color="white" strokeWidth={2.5} />
        </div>
      </div>

      {/* Content */}
      <div className="px-6 pt-4 pb-6">
        <h3
          className="font-['Montserrat'] font-bold text-base mb-2.5"
          style={{ color: activity.color }}
        >
          {activity.nombre}
        </h3>
        <p className="text-[#475569] font-['Montserrat'] text-xs md:text-sm leading-relaxed">
          {activity.descripcion}
        </p>
      </div>
    </div>
  );
}

export default function ActivitiesSection({ activities }) {
  const list = activities.length > 0 ? activities : [];

  return (
    <section id="actividades" className="py-14 md:py-20 bg-[#F0F8FF]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-[#0072A4]/10 rounded-full px-5 py-2 mb-5">
            <Zap size={16} color="#0072A4" />
            <span className="text-[#0072A4] font-['Montserrat'] font-bold text-[10px] uppercase tracking-[0.18em]">Actividades del Campus</span>
          </div>
          <h2
            className="font-['Montserrat'] font-extrabold text-[#0F172A] mb-5"
            style={{ fontSize: "clamp(1.25rem, 1.8vw, 1.625rem)", letterSpacing: "-0.01em", lineHeight: 1.2 }}
            data-testid="activities-title"
          >
            Una semana llena de aventuras
          </h2>
          <p className="text-[#475569] font-['Montserrat'] text-sm md:text-[0.9375rem] max-w-xl mx-auto leading-relaxed">
            Cada día es diferente y lleno de emoción. Kayak, BTT, tecnología AR y mucho más esperan a tu hijo/a.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {list.map((activity, index) => (
            <ActivityCard key={activity.id || index} activity={activity} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
